import React from 'react';
import { SliderCheckBoxTemplate } from 'themes/components';
import PropTypes from 'prop-types';

class SliderCheckBox extends React.Component {
	render() {
		return <SliderCheckBoxTemplate {...this.props} />;
	}
}

SliderCheckBox.propTypes = {
	field: PropTypes.object,
	id: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	label: PropTypes.string,
	onChange: PropTypes.func,
	customMessage: PropTypes.string,
	labelSuffix: PropTypes.node,
};

export default SliderCheckBox;
